var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticket-container"},[_c('span',{staticClass:"ticket-container-title"},[_vm._v("\n    "+_vm._s(_vm.$t('remainingTime'))+"\n  ")]),_c('span',{staticClass:"timer",attrs:{"translate":"no"}},[_vm._v(_vm._s(_vm.timer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }